import { trackEvent } from '../jentis/events';
import { EXPRESS_DESIGNER_TRACKING_ACTION, EXPRESS_DESIGNER_TRACKING_LABELS } from './constants';

export const trackInitializeExpressDesigner = (step: string) =>
  trackEvent(step, EXPRESS_DESIGNER_TRACKING_ACTION, EXPRESS_DESIGNER_TRACKING_LABELS.INIT);

export const trackUploadImage = (step: string) =>
  trackEvent(step, EXPRESS_DESIGNER_TRACKING_ACTION, EXPRESS_DESIGNER_TRACKING_LABELS.UPLOAD_PHOTO);

export const trackAddProductToCart = (step: string, productLabel: string) =>
  trackEvent(step, EXPRESS_DESIGNER_TRACKING_ACTION, `${EXPRESS_DESIGNER_TRACKING_LABELS.ADD_TO_CART}${productLabel}`);

export const trackShowProductDetails = (step: string, productLabel: string) =>
  trackEvent(step, EXPRESS_DESIGNER_TRACKING_ACTION, `${EXPRESS_DESIGNER_TRACKING_LABELS.SHOW_PRODUCT_DETAILS}${productLabel}`);
